import React from 'react';
import PropTypes from 'prop-types';
import { Popover, Whisper, Icon } from 'rsuite';

// styles
import styles from './PopoverIcon.module.less';

const PopoverIcon = ({ popoverContent = '' }) => {
  const speaker = (
    <Popover className={styles.popoverIconContainer}>
      {popoverContent}
    </Popover>
  );

  return (
    <Whisper speaker={speaker} trigger="hover" placement="bottomEnd" enterable>
      <Icon icon="question-circle" />
    </Whisper>
  );
};

PopoverIcon.propTypes = {
  popoverContent: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
};

export default PopoverIcon;



// WEBPACK FOOTER //
// ./src/components/PopoverIcon/PopoverIcon.jsx